import { empresaService } from './core';

export const listEmpresas = empresaService.listEmpresas;
export const listEmpresasWithStats = empresaService.listEmpresasWithStats;
export const getEmpresaLockHolders = empresaService.getLockHolders;
export const searchEmpresas = empresaService.searchEmpresas;
export const getEmpresa = empresaService.getEmpresa;
export const getEmpresaByLead = empresaService.getEmpresaByLead;
export const createEmpresa = empresaService.createEmpresa;
export const updateEmpresa = empresaService.updateEmpresa;
export const deleteEmpresa = empresaService.deleteEmpresa;

// ─── Filiais (demais CNPJs do grupo) ─────────────────────────────
export const listFiliais = empresaService.listFiliais;
export const salvarFilial = empresaService.salvarFilial;
export const removerFilial = empresaService.removerFilial;

export {
  MIN_EMPRESA_SEARCH_CHARS,
  cnpjValido,
  formatarCnpj,
  motivoFilialInvalida,
  normalizarCnpj,
  normalizeEmpresaName,
} from '@modules/empresas';
export type {
  Empresa,
  EmpresaVisualStatus,
  EmpresaAuthor,
  EmpresaLeadStage,
  EmpresaLeadSummary,
  EmpresaHistoryEntry,
  EmpresaResponsible,
  EmpresaWithStats,
  CreateEmpresaInput,
  EmpresaUpdates,
  EmpresaLockHolder,
  EmpresaFilial,
  SalvarFilialInput,
} from '@modules/empresas';
